import SiteNav from '@/pages/home/components/SiteNav';
import Hero from '@/pages/home/components/Hero';
import FilmProfile from '@/pages/home/components/FilmProfile';
import StorySection from '@/pages/home/components/StorySection';
import SubtitleTypes from '@/pages/home/components/SubtitleTypes';
import VersionCompare from '@/pages/home/components/VersionCompare';
import LanguageTabs from '@/pages/home/components/LanguageTabs';
import GuideSteps from '@/pages/home/components/GuideSteps';
import FaqSection from '@/pages/home/components/FaqSection';
import RelatedTerms from '@/pages/home/components/RelatedTerms';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="w-full overflow-x-hidden bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <FilmProfile />
        <StorySection />
        <SubtitleTypes />
        <VersionCompare />
        <LanguageTabs />
        <GuideSteps />
        <FaqSection />
        <RelatedTerms />
      </main>
      <SiteFooter />
    </div>
  );
}